import React from 'react'
import '../../../App.scss';
import Grid from "@material-ui/core/Grid";
import Button from "../../pageComponents/Settings/Free/Button";
import failed from "../../../assets/images/ic_faild.png";
import Exit from "../../../assets/images/exit.png";


class CustomDialog extends React.Component{
    constructor() {
        super()
        this.state={
        }
    }
    componentDidMount() {
    }
    render() {
        const {button,data:{dialog,success}}=this.props.data
        const okButton={
            text:dialog.ok?dialog.ok.text:'',
            backgroundColor:'green',
            bottomFontSize:'15px',
            buttonTextColor:'#ffffff',
            borderColor:'transparent',
            action:dialog.ok?dialog.ok.action:''
        }
        const cancelButton={
                text:dialog.cancel?dialog.cancel.text:'',
                backgroundColor:'grey',
                bottomFontSize:'15px',
                buttonTextColor:'#ffffff',
                borderColor:'transparent',
                action:dialog.cancel?dialog.cancel.action:''
        }
        return (

            <Grid sm={12} xs={12} alignItems={"center"} container justify={"flex-end"}
                className='dialog' style={{backgroundColor:dialog.style.background,border:'none',height:'100%',width:'100%'}}>
                <Grid sm={12} xs={12} alignItems={"center"} direction={"row"} style={{height:'50px',position:'relative',cursor:'none'}} container justify={"center"}>
                    <Button data={button}/>
                    <img src={dialog.icon?dialog.icon:Exit} style={{width:'15%', bottom:'-50%',position:'absolute'}} alt=""/>
                </Grid>
                <Grid sm={11} xs={11} style={{backgroundColor:dialog.style.contentColor,border:'none'}} direction={"row-reverse"} className='dialog-text-container' alignItems={"center"}  container justify={"center"}>
                    <Grid  sm={12} xs={12} alignItems={"center"} direction={"row-reverse"}  justify={"center"} container
                           style={{padding:'10px 0',
                            margin:'15px 0 0 0'}}>
                        <p style={{color:dialog.style.contentTextColor,fontSize:dialog.style.fontSize}}>
                            {dialog.message}
                        </p>
                    </Grid>
                    <Grid  sm={12} xs={12} alignItems={"center"}  direction={"row-reverse"} justify={"space-around"} container>
                        {
                            dialog.ok &&
                            <Grid className='clickable' sm={5} xs={5} alignItems={"center"} direction={"row-reverse"} justify={"center"}
                                 onClick={()=>{
                                     this.props.action(okButton.action)
                                 }} container style={{height: '50px'}}>
                                <Button data={okButton}/>
                            </Grid>
                        }
                        {
                            dialog.cancel &&
                            <Grid className='clickable' sm={5} xs={5} alignItems={"center"} direction={"row-reverse"}  justify={"center"} container style={{height:'50px'}}
                                  onClick={()=>{
                                      this.props.action(cancelButton.action)
                                  }}
                            >
                                <Button data={cancelButton}/>
                            </Grid>
                        }
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}
export default CustomDialog